import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SupportTeam } from "../../../utils/types";
import { SupportTeamState } from "../../types";
import { axiosObj } from "../../../config/apiClients";

const initialState: SupportTeamState = {
  isLoading: false,
  supportTeams: []
}

export const getAllSupportDetails = createAsyncThunk(
  "/supportTeam/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get('/supportDetails/getAll');
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Support Team' });
    }
  }
);

export const createSupportDetails = createAsyncThunk(
  "/supportTeam/create",
  async (supportDetails: SupportTeam, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/supportDetails/create', supportDetails);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Add Support Team' });
    }
  }
)

export const updateSupportDetails = createAsyncThunk(
  "/supportTeam/update",
  async (supportDetails: SupportTeam, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/supportDetails/update', { ...supportDetails, id: supportDetails._id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Update Support Team' });
    }
  }
)

export const deleteSupportDetails = createAsyncThunk(
  "/supportTeam/delete",
  async (supportId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.delete('/supportDetails/delete', { data: { supportId } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Delete Support Team' });
    }
  }
)

const supportDetailSlice = createSlice({
  name: "SupportDetails",
  initialState,
  reducers: {
    updateSupportDetailItem: (state, action) => {
      const index = state.supportTeams.findIndex((team) => team._id === action.payload._id);
      if (index !== -1) {
        state.supportTeams[index] = action.payload;
      }
    },
    deleteSupportDetailItem: (state, action) => {
      state.supportTeams = state.supportTeams.filter((item) => item._id !== action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSupportDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllSupportDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.supportTeams = action.payload.payload.allSupportDetails
      })
      .addCase(getAllSupportDetails.rejected, (state) => {
        state.isLoading = false;
        state.supportTeams = [];
      })
      .addCase(createSupportDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createSupportDetails.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createSupportDetails.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(updateSupportDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSupportDetails.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateSupportDetails.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteSupportDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteSupportDetails.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteSupportDetails.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { updateSupportDetailItem, deleteSupportDetailItem } = supportDetailSlice.actions;

export default supportDetailSlice.reducer;